<!--  -->
<template>
  <div>
    <div class="el-image">
      <img class="image_box" src="https://ywopen-1252317822.file.myqcloud.com/openwx/wechatactivity/template/default/preview.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      img: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val) {
      console.log('val', val)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.el-image{
  height: 590px;
}
.image_box{
    object-fit: fill;
    height: auto;
}
</style>
